var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from 'capacitor-native-biometric';
import MobileRemove from '@dev-togetherprice/icons.mobile-remove';
import FaceID from '@dev-togetherprice/icons.face-id';
import { Button } from '@material-ui/core';
import { mergeClasses } from '@material-ui/styles';
const isNativeBiometricAvailable = Capacitor.isPluginAvailable('NativeBiometric') &&
    Capacitor.getPlatform() !== 'web';
const hasBiometricCredentials = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isNativeBiometricAvailable) {
        return false;
    }
    return NativeBiometric.isAvailable().then(({ isAvailable }) => {
        if (!isAvailable) {
            return false;
        }
        return NativeBiometric.getCredentials({
            server: 'app.togetherprice.com',
        })
            .then(() => true)
            .catch(() => false);
    });
});
const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridTemplateRows: 'repeat(3, minmax(50px, 1fr))',
        flex: 1,
    },
    button: {
        width: '100%',
        height: '100%',
    },
    text: {
        fontSize: 21,
    },
}));
const MobileKeyboard = ({ onKeyDown, faceId = true, faceIdCallback, classes: newClasses = {}, }) => {
    const baseClasses = useStyles();
    const classes = mergeClasses({
        newClasses,
        baseClasses,
        Component: MobileKeyboard,
    });
    const [isBiometricActive, setBiometric] = useState(false);
    useEffect(() => {
        hasBiometricCredentials().then((has) => {
            setBiometric(has);
        });
    }, []);
    return (React.createElement("div", { className: classes.root }, [
        ...Array.from({ length: 9 }, (_, i) => i + 1),
        faceId && isBiometricActive
            ? {
                preview: React.createElement(FaceID, null),
                onClick: faceIdCallback,
            }
            : '',
        '0',
        {
            preview: React.createElement(MobileRemove, { fontSize: 'medium' }),
            onClick: () => onKeyDown('remove'),
        },
    ].map((item, index) => {
        const onClick = typeof item === 'object' ? item === null || item === void 0 ? void 0 : item.onClick : () => onKeyDown(`${item}`);
        return (React.createElement(Button, { key: `key-button-${index}`, className: classes.button, variant: 'text', onClick: onClick, disabled: !onClick || !item, fullWidth: true }, typeof item === 'object' ? (item === null || item === void 0 ? void 0 : item.preview) : (React.createElement(Typography, { className: classes.text, variant: 'body1' }, item))));
    })));
};
export default MobileKeyboard;
